/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import {
  dispatchProviderSummTabData,
  dispatchProviderSummaryGrid,
} from '../../store/actions';

export default (props) => {
  const dispatch = useDispatch();
  // use Selector function
  const providerSummaryGridData = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer?.providerSummaryGrid
  );
  const providerSummaryTabData = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer?.providerSummTabObj
  );
  const { value, data, column } = props;
  let rowIndex = 0;
  if (providerSummaryGridData && providerSummaryGridData.length > 0) {
    rowIndex = providerSummaryGridData?.findIndex((x) => {
      return x.providerId === props.data?.providerId;
    });
  }
  // handing onClick event & check validation on filed level
  const handleOnClickEvent = (e) => {
    const newObj = [...providerSummaryGridData];
    newObj[rowIndex][props?.column.colId] = e.target.checked ? 1 : 0;
    newObj[rowIndex].isUpdate = true;
    props.node.setDataValue(props?.column.colId, e.target.checked ? 1 : 0);
    dispatch(
      dispatchProviderSummTabData({
        ...providerSummaryTabData,
        disabledSaveCancelBtn: false,
      })
    );
    dispatch(dispatchProviderSummaryGrid(newObj));
  };
  if (column?.colId === 'reviewSelect') {
    return (
      <>
        <div
          className="tbl-checkbox frr-checkbox-no-label"
          data-testid="checkbox-com"
        >
          {parseInt(data.isReviewSelect, [0, 1]) === 1 ? (
            <FormControlLabel
              label=""
              control={<Checkbox color="primary" />}
              checked
              value
              disabled
            />
          ) : (
            <FormControlLabel
              label=""
              control={<Checkbox color="primary" />}
              checked={parseInt(value, [0, 1]) === 1}
              value={parseInt(value, [0, 1]) === 1}
              onClick={(e) => {
                handleOnClickEvent(e);
              }}
            />
          )}
        </div>
      </>
    );
  }
  if (column?.colId === 'reviewComplete') {
    return (
      <>
        <div className="tbl-checkbox frr-display-hidden-checkbox-label">
          {parseInt(data.isReviewComplite, [0, 1]) === 0 &&
          data.reviewSeqNum !== null ? (
            <FormControlLabel
              label=""
              control={<Checkbox color="primary" />}
              checked={parseInt(value, [0, 1]) === 1}
              value={parseInt(value, [0, 1]) === 1}
              onClick={(e) => {
                handleOnClickEvent(e);
              }}
            />
          ) : (
            <FormControlLabel
              label=""
              control={<Checkbox color="primary" />}
              checked
              value
              disabled
            />
          )}
        </div>
      </>
    );
  }
  return '';
};
